// extracted by mini-css-extract-plugin
module.exports = {"container":"SectionContentContainer_container__gV3Iv"};